import React from 'react'
import { Group } from '@mantine/core'
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import isFuture from 'date-fns/isFuture'
import parseISO from 'date-fns/parseISO'

import { View } from './Calendar'
import { NoticeBox, usePopoverStyles } from './CalendarEvent'
import {
  CourtReporterEventEntries,
  CourtReporterEventHeader,
  InlinePreview,
  LargePreview,
  SmallPreview,
} from './CourtReporterCalendarEvent'
import { EventPopover } from './EventPopover'

import { CalendarCourtReporterEvent } from '@/apiClient'
import { EventDetailButton } from '@/components/Event/EventDetailButton'

// An event on the calendar of the court reporter booked on it.
export const CourtReporterOwnCalendarEvent: React.FC<{
  event: CalendarCourtReporterEvent
  view: View
}> = ({ event, view }) => {
  const popoverStyles = usePopoverStyles(view)
  const status = event.court_reporter_status

  const Preview = {
    month: SmallPreview,
    week: LargePreview,
    day: LargePreview,
    list: InlinePreview,
    listCustom: InlinePreview,
  }[view]

  return (
    <EventPopover
      handle={<Preview event={event} status={status} />}
      header={<CourtReporterEventHeader event={event} status={status} />}
      position={popoverStyles.position}
    >
      <>
        <Group spacing="md">
          <CourtReporterEventEntries event={event} />

          <Group mb="xl" spacing="xs" className="w-full">
            {status === 'cancelled' && (
              <NoticeBox>This event was canceled.</NoticeBox>
            )}

            {status === 'booked' &&
              event.status === 'upcoming' &&
              isFuture(parseISO(event.datetime)) && (
                <NoticeBox>
                  Event is starting in{' '}
                  {formatDistanceToNow(parseISO(event.datetime))}
                </NoticeBox>
              )}
          </Group>
        </Group>

        <Group position="right">
          <EventDetailButton event={event} />
        </Group>
      </>
    </EventPopover>
  )
}
